import module from 'fanconsultores/module.js'
import template from './template.html'

class FanconsultoresAdminAuthComponent {
  constructor ($session, $state) {
    this.$session = $session
    this.$state = $state
    this.onClose = null
    this.onCancel = null
    this.error = null
    this.loading = false
    this.credential = {
      username: '',
      password: '',
    }
  }

  cancelar () {
    this.onCancel()
  }

  aceptar () {
    if (this.loading) return

    this.loading = true

    return this.$session.auth(this.credential)
      .then((data) => (this.onClose({$event: {data: data}})))
      .catch((error) => {
        if (error === 'PASS_EXPIRED') {
          this.$state.go('app.sesion.pass_expired', {credential: this.credential}, {location: false})
        } else {
          this.error = error
        }
      })
      .finally(() => (this.loading = false))
  }
}

module.component('fanconsultoresAdminAuth', {
  controller: FanconsultoresAdminAuthComponent,
  template,
  bindings: {
    onClose: '&',
    onCancel: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/auth/component.js